// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.knFtFENTERQJ0B {
  padding: var(--ds-space-150, 10px);
}
.knFtFENTERQJ0B .Bur5JZlh516SOP {
  font-weight: var(--ds-font-weight-regular, 400);
}
.knFtFENTERQJ0B .RFKbZyxINDIXny {
  margin-top: var(--ds-space-500, 40px);
  color: var(--ds-text, #172b4d);
  font-size: 24px;
  letter-spacing: -0.01em;
  line-height: 28px;
  font-weight: var(--ds-font-weight-semibold, 600);
  margin-top: var(--ds-space-300, 25px);
}
.knFtFENTERQJ0B .KC0Juw_PZr9hfc {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 64px;
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.knFtFENTERQJ0B .CT1HaGft3ZaT_9 {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  margin-bottom: var(--ds-space-0, 0px);
  color: var(--ds-text, #172b4d);
  font-size: 12px;
  text-align: center;
}
.knFtFENTERQJ0B .CT1HaGft3ZaT_9 strong {
  width: 100%;
}
.knFtFENTERQJ0B .iTaEeCSUEO_EmT {
  font-weight: var(--ds-font-weight-regular, 400);
  display: flex;
  align-items: center;
  min-height: 48px;
  font-size: 12px;
  line-height: 16px;
}
.knFtFENTERQJ0B .nCNr9mdzRaJoun {
  margin-top: 52px;
  color: var(--ds-text, #172b4d);
  font-size: 35px;
  letter-spacing: -0.01em;
  line-height: 40px;
  font-weight: var(--ds-font-weight-semibold, 600);
  overflow-wrap: break-word;
  font-size: 26px;
}
.knFtFENTERQJ0B .UK839ODZk80Wf1,
.knFtFENTERQJ0B .Bn37OBInBT_Wsa,
.knFtFENTERQJ0B .Hq2b_o_CIJOYRG {
  font-weight: var(--ds-font-weight-regular, 400);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  text-align: center;
}
.knFtFENTERQJ0B .TYQSlv0ibDNCST {
  margin-top: var(--ds-space-200, 16px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
}
.knFtFENTERQJ0B .Bn37OBInBT_Wsa {
  /* stylelint-disable-next-line design-system/ensure-design-token-usage -- (spacing) */
  margin: var(--ds-space-400, 32px) var(--ds-space-300, 25px) var(--ds-space-300, 25px) 30px;
}
.knFtFENTERQJ0B:nth-last-child(2) {
  border-top: 3px solid var(--ds-border-discovery, #8270db);
  border-right: 4px solid var(--ds-border-discovery, #8270db);
  border-left: 3px solid var(--ds-border-discovery, #8270db);
}
.knFtFENTERQJ0B:nth-last-child(2) .RFKbZyxINDIXny {
  margin-top: var(--ds-space-050, 3px);
}
.knFtFENTERQJ0B:nth-last-child(2)::before {
  margin-top: var(--ds-space-250, 20px);
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
  font-weight: var(--ds-font-weight-semibold, 600);
  content: attr(data-value);
  position: relative;
  top: var(--ds-space-negative-200, -15px);
  width: 85px;
  height: 24px;
  padding: var(--ds-space-075, 5px);
  border-radius: var(--ds-radius-xsmall, 2px);
  background-color: var(--ds-border-discovery, #8270db);
  color: var(--ds-text-inverse, #ffffff);
  line-height: inherit;
}
`, ""]);
// Exports
export var planCell = `knFtFENTERQJ0B`;
export var purchase = `Bur5JZlh516SOP`;
export var name = `RFKbZyxINDIXny`;
export var info = `KC0Juw_PZr9hfc`;
export var infoHeading = `CT1HaGft3ZaT_9`;
export var infoBody = `iTaEeCSUEO_EmT`;
export var price = `nCNr9mdzRaJoun`;
export var frequency = `UK839ODZk80Wf1`;
export var pricingVaries = `Bn37OBInBT_Wsa`;
export var currentPlan = `Hq2b_o_CIJOYRG`;
export var pricingVariesRefreshed = `TYQSlv0ibDNCST`;
export default ___CSS_LOADER_EXPORT___;
